export default function PageHeader({ title, subtitle, children, testId }) {
  return (
    <div
      data-testid={testId}
      className="px-8 py-6 grid-border-b flex items-start justify-between gap-6"
      style={{ borderBottom: "1px solid #1f1f22" }}
    >
      <div>
        <div className="overline mb-2">{subtitle || "monitoring"}</div>
        <h1 className="text-3xl sm:text-4xl font-mono tracking-tighter uppercase font-medium text-white">
          {title}
        </h1>
      </div>
      {children ? <div className="flex items-center gap-2">{children}</div> : null}
    </div>
  );
}
